import PaintBrushSvg from "./PaintBrushSvg";
import {
    asLightSvg,
    asDarkSvg,
    asThemedSvg
} from "../../hocs";

const LightPaintBrushSvg = asLightSvg(PaintBrushSvg);
const DarkPaintBrushSvg = asDarkSvg(PaintBrushSvg);
const ThemedPaintBrushSvg = asThemedSvg(PaintBrushSvg);

export default PaintBrushSvg;
export {
    PaintBrushSvg,
    LightPaintBrushSvg,
    DarkPaintBrushSvg,
    ThemedPaintBrushSvg
};
